// extracted by mini-css-extract-plugin
export default {"search-bar":"SearchBar_search-bar__CIkRu","search-input":"SearchBar_search-input__RSx9J","search-icon":"SearchBar_search-icon__eWjqL"};